import { useMutation } from '@apollo/client/react';
import { gql } from '@apollo/client';
import { PROJECT_SITE_INSPECTIONS_QUERY } from './useProjectSiteInspections';

const DELETE_SITE_INSPECTION_MUTATION = gql`
  mutation DeleteSiteInspection($id: ID!) {
    deleteSiteInspection(id: $id) {
      success
    }
  }
`;

export function useDeleteSiteInspection(projectId: string) {
  const [mutation, { loading, error }] = useMutation(DELETE_SITE_INSPECTION_MUTATION, {
    refetchQueries: [
      { query: PROJECT_SITE_INSPECTIONS_QUERY, variables: { projectId, page: 1, limit: 20 } },
    ],
  });

  const deleteSiteInspection = async (id: string) => {
    const { data } = await mutation({ variables: { id } });
    return (data as any)?.deleteSiteInspection?.success;
  };

  return { deleteSiteInspection, loading, error };
}
